var map = {
	"./bh-ico-active.svg": 1780,
	"./bh-ico.svg": 1781,
	"./bonus-ico-active.svg": 1782,
	"./bonus-ico.svg": 1783,
	"./deposit-ico.svg": 1784,
	"./deposit-ico.webp": 1785,
	"./edit-icon.svg": 1786,
	"./fb-ico.svg": 1787,
	"./instant-rebate-ico-active.svg": 1788,
	"./instant-rebate-ico.svg": 1789,
	"./mall-ico-active.svg": 1790,
	"./mall-ico.svg": 1791,
	"./msg-ico-active.svg": 1792,
	"./msg-ico.svg": 1793,
	"./pi-ico-active.svg": 1794,
	"./pi-ico.svg": 1795,
	"./rf-ico-active.svg": 1796,
	"./rf-ico.svg": 1797,
	"./rh-ico-active.svg": 1798,
	"./rh-ico.svg": 1799,
	"./th-ico-active.svg": 1800,
	"./th-ico.svg": 1801,
	"./vip-ico-active.svg": 1802,
	"./vip-ico.svg": 1803,
	"./withdrawal-ico.svg": 1804,
	"./withdrawal-ico.webp": 1805,
	"./wl-ico-active.svg": 1806,
	"./wl-ico.svg": 1807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 469;